import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/utils/axios';
import { REVENDA_ROTAS } from '@/utils/apiRoutes';
import { getNomeAbreviado } from '@/utils/tipoProduto';

export const useTipoProdutosStore = defineStore('tipoProdutos', () => {
  const tipoProdutos = ref([]);
  const loading = ref(false);
  const error = ref(null);

  /**
   * Busca os tipos de produtos disponíveis no sistema
   * @returns {Promise<Array>} Lista formatada de tipos de produtos
   */
  const buscarTipoProdutos = async () => {
    loading.value = true;
    error.value = null;

    try {
      const response = await useApi(REVENDA_ROTAS.BUSCAR_TIPO_PRODUTOS).fetch({ 
        params: { status: 1 } 
      });
      
      if (response?.status === 'success' && Array.isArray(response.data)) {
        tipoProdutos.value = response.data.map(produto => {
          // Use a função de utilidade para nomenclatura consistente
          let title = getNomeAbreviado(produto.id);
          
          // Se não existir mapeamento, use o formato original
          if (!title) {
            title = `${produto.tipo} (${produto.peso}kg)`;
          }
          
          return {
            title,
            value: produto.id.toString(),
            // Preserva os atributos originais para uso em outros lugares
            tipo: produto.tipo,
            peso: produto.peso,
            id: produto.id
          };
        });
        
        // Add the "Todos" option at the beginning of the array
        tipoProdutos.value.unshift({ title: 'Todos', value: '0' });
        
        return tipoProdutos.value;
      } else {
        throw new Error('Resposta inválida da API');
      }
    } catch (err) {
      error.value = err.message || 'Erro ao buscar tipos de produtos';
      console.error('Erro ao buscar tipos de produtos:', err);
      return [];
    } finally {
      loading.value = false;
    }
  };

  return {
    tipoProdutos,
    loading,
    error,
    buscarTipoProdutos
  };
});
